// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4":"37b5900b571a1327b850","40":"ea85a606752fc4577bd1"}[chunkId] + ".css";
};